// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectConfiguration_PotentialConfigsQueryVariables = Types.Exact<{
  filter: Types.CheckoutConfigsFilter;
  structureId: Types.Scalars['ID']['input'];
}>;


export type SelectConfiguration_PotentialConfigsQuery = { __typename?: 'Query', checkoutConfigs: { __typename?: 'CheckoutConfigsPage', entities: Array<{ __typename?: 'CheckoutConfig', id: string, updatedAt: Types.Scalars['DateTime']['input'], createdBy?: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined } | null | undefined, config: { __typename?: 'CheckoutConfigSafeSide', side: Types.CheckoutConfigSideType, name: string, exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined } }> } };

export type SelectConfiguration_CheckoutConfigQueryVariables = Types.Exact<{
  configId: Types.Scalars['ID']['input'];
  structureId: Types.Scalars['ID']['input'];
}>;


export type SelectConfiguration_CheckoutConfigQuery = { __typename?: 'Query', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, config: { __typename?: 'CheckoutConfigSide', productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, options: Array<{ __typename?: 'CheckoutConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } }> } } };

export type SelectConfiguration_PotentialCheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, updatedAt: Types.Scalars['DateTime']['input'], createdBy?: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined } | null | undefined, config: { __typename?: 'CheckoutConfigSafeSide', side: Types.CheckoutConfigSideType, name: string, exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined } };

export type SelectConfiguration_InternalUserFragment = { __typename?: 'InternalUser', id: string, name: string, avatar: string };

export type SelectConfiguration_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, config: { __typename?: 'CheckoutConfigSide', productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, options: Array<{ __typename?: 'CheckoutConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } }> } };

export const SelectConfiguration_InternalUserFragmentDoc = gql`
    fragment SelectConfiguration_InternalUser on InternalUser {
  id
  name
  avatar
}
    `;
export const SelectConfiguration_PotentialCheckoutConfigFragmentDoc = gql`
    fragment SelectConfiguration_PotentialCheckoutConfig on CheckoutConfig {
  id
  updatedAt
  createdBy {
    id
    internalUser {
      ...SelectConfiguration_InternalUser
    }
  }
  config: safeSideFor(structureId: $structureId) {
    side
    name
    productOffering {
      ...Named
    }
    aggregateVersion {
      id
      displayVersion
    }
    exteriorOptionNames
    interiorOptionNames
  }
}
    ${SelectConfiguration_InternalUserFragmentDoc}
${NamedFragmentDoc}`;
export const SelectConfiguration_CheckoutConfigFragmentDoc = gql`
    fragment SelectConfiguration_CheckoutConfig on CheckoutConfig {
  id
  config: sideFor(structureId: $structureId) {
    productOffering {
      id
    }
    aggregateVersion {
      id
    }
    options {
      id
      readyPlanOption {
        id
      }
    }
  }
}
    `;
export const SelectConfiguration_PotentialConfigsDocument = gql`
    query SelectConfiguration_PotentialConfigs($filter: CheckoutConfigsFilter!, $structureId: ID!) {
  checkoutConfigs(filter: $filter, order: {reservedAt: DESC}) {
    entities {
      ...SelectConfiguration_PotentialCheckoutConfig
    }
  }
}
    ${SelectConfiguration_PotentialCheckoutConfigFragmentDoc}`;

/**
 * __useSelectConfiguration_PotentialConfigsQuery__
 *
 * To run a query within a React component, call `useSelectConfiguration_PotentialConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectConfiguration_PotentialConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectConfiguration_PotentialConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useSelectConfiguration_PotentialConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables> & ({ variables: SelectConfiguration_PotentialConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>(SelectConfiguration_PotentialConfigsDocument, options);
      }
export function useSelectConfiguration_PotentialConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>(SelectConfiguration_PotentialConfigsDocument, options);
        }
// @ts-ignore
export function useSelectConfiguration_PotentialConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>;
export function useSelectConfiguration_PotentialConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_PotentialConfigsQuery | undefined, SelectConfiguration_PotentialConfigsQueryVariables>;
export function useSelectConfiguration_PotentialConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>(SelectConfiguration_PotentialConfigsDocument, options);
        }
export type SelectConfiguration_PotentialConfigsQueryHookResult = ReturnType<typeof useSelectConfiguration_PotentialConfigsQuery>;
export type SelectConfiguration_PotentialConfigsLazyQueryHookResult = ReturnType<typeof useSelectConfiguration_PotentialConfigsLazyQuery>;
export type SelectConfiguration_PotentialConfigsSuspenseQueryHookResult = ReturnType<typeof useSelectConfiguration_PotentialConfigsSuspenseQuery>;
export type SelectConfiguration_PotentialConfigsQueryResult = ApolloReactCommon.QueryResult<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>;
export const SelectConfiguration_CheckoutConfigDocument = gql`
    query SelectConfiguration_CheckoutConfig($configId: ID!, $structureId: ID!) {
  checkoutConfig(id: $configId) {
    ...SelectConfiguration_CheckoutConfig
  }
}
    ${SelectConfiguration_CheckoutConfigFragmentDoc}`;

/**
 * __useSelectConfiguration_CheckoutConfigQuery__
 *
 * To run a query within a React component, call `useSelectConfiguration_CheckoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectConfiguration_CheckoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectConfiguration_CheckoutConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useSelectConfiguration_CheckoutConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables> & ({ variables: SelectConfiguration_CheckoutConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>(SelectConfiguration_CheckoutConfigDocument, options);
      }
export function useSelectConfiguration_CheckoutConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>(SelectConfiguration_CheckoutConfigDocument, options);
        }
// @ts-ignore
export function useSelectConfiguration_CheckoutConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>;
export function useSelectConfiguration_CheckoutConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_CheckoutConfigQuery | undefined, SelectConfiguration_CheckoutConfigQueryVariables>;
export function useSelectConfiguration_CheckoutConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>(SelectConfiguration_CheckoutConfigDocument, options);
        }
export type SelectConfiguration_CheckoutConfigQueryHookResult = ReturnType<typeof useSelectConfiguration_CheckoutConfigQuery>;
export type SelectConfiguration_CheckoutConfigLazyQueryHookResult = ReturnType<typeof useSelectConfiguration_CheckoutConfigLazyQuery>;
export type SelectConfiguration_CheckoutConfigSuspenseQueryHookResult = ReturnType<typeof useSelectConfiguration_CheckoutConfigSuspenseQuery>;
export type SelectConfiguration_CheckoutConfigQueryResult = ApolloReactCommon.QueryResult<SelectConfiguration_CheckoutConfigQuery, SelectConfiguration_CheckoutConfigQueryVariables>;